import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components/styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },

    button: {
      minWidth: 202,

      [mediaQuery(breakpoints.mobile)]: {
        width: '100%',
      },
    },

    loader: {
      fill: 'var(--markets-text-default)',
      animation: '$spin 1s linear infinite',
    },

    result: {
      alignItems: 'center',
      background: 'var(--backgrounds-tint-2)',
      borderRadius: 8,
      display: 'flex',
      height: 48,
      padding: 16,
      width: 'fit-content',

      [mediaQuery(breakpoints.mobile)]: {
        flexWrap: 'wrap',
        height: 'auto',
      },
    },
  }),
  {
    name: 'GenerateButton',
  },
);

export default useStyles;
